import React, { useState, useContext } from 'react'
import {
	Button, Modal, ModalHeader, ModalBody, ModalFooter,
	FormGroup, Label, Input, Alert
} from 'reactstrap'
import { SessionContext } from '../../contexts/SessionProvider'
import AuctionTabsService from '../../services/AuctionTabsService'

/**
 * Modal for moving a shipped vehicle to Physical Auction.
 * BRD: Check in vehicle to physical auction lane upon arrival.
 */
const MoveToPhysicalAuctionModal = ({ isOpen, toggle, auction, onSuccess }) => {
	const { sessionKey } = useContext(SessionContext)
	const [notes, setNotes] = useState('')
	const [isSubmitting, setIsSubmitting] = useState(false)
	const [error, setError] = useState(null)

	const handleSubmit = async () => {
		setIsSubmitting(true)
		setError(null)

		try {
			await AuctionTabsService.moveToPhysicalAuction(auction?.auctionId, notes, sessionKey)
			setNotes('')
			onSuccess?.()
			toggle()
		} catch (err) {
			setError(err.response?.data?.message || 'Failed to move vehicle to physical auction.')
		} finally {
			setIsSubmitting(false)
		}
	}

	const handleClose = () => {
		setNotes('')
		setError(null)
		toggle()
	}

	if (!auction) return null

	return (
		<Modal isOpen={isOpen} toggle={handleClose} centered>
			<ModalHeader toggle={handleClose}>
				Move to Physical Auction
			</ModalHeader>
			<ModalBody>
				{error && <Alert color="danger">{error}</Alert>}
				
				<p>
					You are about to check in this vehicle to Physical Auction:
				</p>
				<div className="bg-light p-3 rounded mb-3">
					<strong>{auction.year} {auction.make} {auction.model}</strong>
					<br />
					<small className="text-muted">VIN: {auction.vin}</small>
					{auction.stockNumber && (
						<>
							<br />
							<small className="text-muted">Stock #: {auction.stockNumber}</small>
						</>
					)}
				</div>
				
				<FormGroup>
					<Label for="physicalAuctionNotes">Notes (Optional)</Label>
					<Input
						type="textarea"
						id="physicalAuctionNotes"
						value={notes}
						onChange={(e) => setNotes(e.target.value)}
						placeholder="Enter lane assignment or other notes..."
						rows={3}
					/>
				</FormGroup>
				
				<Alert color="warning" className="mb-0">
					<small>
						<strong>Important:</strong> Once checked in to Physical Auction, 
						the vehicle will be available for live bidding at the physical location.
					</small>
				</Alert>
			</ModalBody>
			<ModalFooter>
				<Button color="secondary" onClick={handleClose} disabled={isSubmitting}>
					Cancel
				</Button>
				<Button color="success" onClick={handleSubmit} disabled={isSubmitting}>
					{isSubmitting ? 'Processing...' : 'Check In to Physical Auction'}
				</Button>
			</ModalFooter>
		</Modal>
	)
}

export default MoveToPhysicalAuctionModal
